/**
 * Configuration centralisée de l'API
 * Utilise les variables d'environnement du fichier .env
 */

// URL de base du backend (depuis .env ou fallback)
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://go.cinef.app';

// Exporter les URLs configurées
export const API_URL = `${API_BASE_URL}/api`;
export const STORAGE_URL = `${API_BASE_URL}/storage/`;
export const BASE_URL = API_BASE_URL;

// Helper pour résoudre l'URL complète d'une image
export const resolveImageUrl = (image) => {
    if (!image) return null;
    if (image.startsWith('http://') || image.startsWith('https://')) return image;
    if (image.startsWith('blob:')) return image;
    
    // Si l'image commence par /storage/, remplacer par l'URL complète
    if (image.startsWith('/storage/')) {
        return `${BASE_URL}${image}`;
    }
    if (image.startsWith('storage/')) {
        return `${BASE_URL}/${image}`;
    }
    
    // Sinon, ajouter le préfixe STORAGE
    return `${STORAGE_URL}${image.replace(/^\//, '')}`;
};

// Helper pour résoudre les URLs d'avatar/profil
export const resolveAvatarUrl = (avatar) => {
    if (!avatar) return null;
    if (avatar.startsWith('http://') || avatar.startsWith('https://')) return avatar;
    if (avatar.startsWith('blob:')) return avatar;
    if (avatar.startsWith('/')) return `${BASE_URL}${avatar}`;
    return `${STORAGE_URL}${avatar}`;
};

// Configuration du debug (en développement)
export const DEBUG_API = process.env.REACT_APP_DEBUG_API === 'true';

// Intercepteur de requête fetch avec logging optionnel
export const apiFetch = async (endpoint, options = {}) => {
    const url = endpoint.startsWith('http') ? endpoint : `${API_URL}${endpoint}`;
    
    if (DEBUG_API) {
        console.log(`🌐 API Request: ${options.method || 'GET'} ${url}`);
    }
    
    try {
        const response = await fetch(url, {
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
        
        if (DEBUG_API) {
            console.log(`✅ API Response: ${response.status} ${url}`);
        }
        
        return response;
    } catch (error) {
        if (DEBUG_API) {
            console.error(`❌ API Error: ${url}`, error);
        }
        throw error;
    }
};

const apiConfig = {
    API_URL,
    STORAGE_URL,
    BASE_URL,
    resolveImageUrl,
    resolveAvatarUrl,
    apiFetch,
    DEBUG_API,
};

export default apiConfig;
